import jsPDF from "jspdf";
import "jspdf-autotable";
import * as style from "./ReportStyle";

let globalMode = null; // 🧠 Store mode globally

// 🟢 Header
function pageHeader(doc, data, mode) {
  style.pageBorder(doc);
  style.pageHeder(doc, data, mode);
  style.reportHeder1(doc, data, mode);
}

// 🟢 Body
function reportBody(doc, data, mode) {
  style.tableBody(doc, data, mode);
}

// 🟢 Footer
function pageFooter(doc, data, mode) {
  style.pageFooter(doc, data, mode);
}

// 🧾 Main Function
const LoyaltyReport = (data) => {
  try {
    const mode = globalMode; // ✅ Read from global variable

    if (!Array.isArray(data) || data.length === 0) {
      alert("❌ No valid data to generate report!");
      return;
    }
    const pageFormat = mode === 2 ? "a4" : "a5";
    const pageOrientation = mode === 2 ? "p" : "l";
    const doc = new jsPDF(pageOrientation, "pt", pageFormat);

    // Header
    pageHeader(doc, data, mode);

    // Table Body (depending on mode)
    reportBody(doc, data, mode);

    // Footer
    pageFooter(doc, data, mode);

    doc.setProperties({
      title: `Loyalty Claim Report - Mode ${mode}`,
    });

    // ✅ Open PDF directly in new browser tab (no download)
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl); // 🟢 Open instead of download

  } catch (error) {
    console.error("❌ Error generating LoyaltyReport:", error);
  }
};

// 🟢 Setter for mode
export const setLoyaltyReportMode = (mode) => {
  globalMode = mode;
};

export default LoyaltyReport;
